<template>
  <div class="container mt-5">
      <div class="row">
          <div class="col-md-6">
              <p>
                  Zombie ipsum reversus ab viral inferno, nam rick grimes malum cerebro.
                  De carne lumbering animata corpora quaeritis.
                  Summus brains, morbo vel maleficia? De apocalypsi gorger omero undead survivor dictum mauris.
                  Hi mindless mortuis soulless creaturas, imo evil stalking monstra adventus resi dentevil vultus comedat cerebella viventium.
                  Qui animated corpse, cricket bat max brucks terribilem incessu zomby. The voodoo sacerdos flesh eater, suscitat mortuos comedere carnem virus.
                  Zonbi tattered for solum oculi eorum defunctis go lum cerebro.
                  Nescio brains an Undead zombies. Sicut malus putrid voodoo horror. Nigh tofth eliv ingdead.
              </p>
              <router-link class="btn btn-primary" :to="{name:'users'}">Users</router-link>
              <router-link class="btn btn-success ml-5" :to="{name:'posts'}">Posts</router-link>

          </div>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>